<template>
  <a-locale-provider :locale="locale">
    <div>
      <a-spin id="root_block" :spinning="spinningMain" size="large">
        <div id="app">
          <div id="maindivmenu" v-if="license.status">
            <div
              v-if="placementScope == 'DEFAULT'"
              @click="currentTab = 8"
              :class="{ Active: currentTab == 8 }"
              class="alltabs"
              style="min-width: 200px"
            >
              <div id="OpenApp">
                <a-icon type="inbox" />
                <span>&nbsp;{{ this.$t("PISMO PRZYCHODZĄCE") }} </span>
              </div>
            </div>
            <div
              v-if="placementScope == 'DEFAULT'"
              @click="currentTab = 1"
              :class="{ Active: currentTab == 1 }"
              class="alltabs"
              style="min-width: 200px"
            >
              <div id="OpenApp">
                <a-icon type="inbox" />
                <span>&nbsp;{{ this.$t("Dokumenty") }} </span>
              </div>
            </div>
            <div
              @click="currentTab = 2"
              :class="{ Active: currentTab == 2 }"
              class="alltabs"
            >
              <div id="InvoiceID">
                <a-icon type="account-book" />
                <span>&nbsp;{{ this.$t("FV Kosztowe") }}</span>
              </div>
            </div>
            <div
              @click="currentTab = 3"
              :class="{ Active: currentTab == 3 }"
              class="alltabs"
              style="min-width: 150px"
            >
              <div id="InvoiceID">
                <a-icon type="project" />
                <span>&nbsp;{{ this.$t("FV Sprzedażowe") }}</span>
              </div>
            </div>
            <div
              v-if="isResponsibleExport && placementScope == 'DEFAULT'"
              @click="currentTab = 4"
              :class="{ Active: currentTab == 4 }"
              class="alltabs"
              style="min-width: 120px"
            >
              <div>
                <a-icon type="export" />
                <span>&nbsp;{{ $t("Export") }}</span>
              </div>
            </div>
            <div
              v-if="placementScope == 'DEFAULT'"
              @click="currentTab = 5"
              :class="{ Active: currentTab == 5 }"
              class="alltabs"
              style="min-width: 120px"
            >
              <div>
                <a-icon type="pie-chart" />
                <span>&nbsp;{{ $t("Income statement") }}</span>
              </div>
            </div>
            <!--<div
            v-if="placementScope == 'DEFAULT' && checkbudget"
            @click="
              currentTab = 6;
              checkFacture = false;
            "
            :class="{ Active: currentTab == 6 }"
            class="alltabs"
            style="min-width: 150px"
          >
            <div id="InvoiceID">
              <a-icon type="project" />
              <span>Budżety</span>
            </div>
          </div>-->
            <!-- isAdmin -->
            <div
              v-if="placementScope == 'DEFAULT' && isAdmin"
              @click="currentTab = 7"
              :class="{ Active: currentTab == 7 }"
              class="alltabs"
            >
              <div id="OpenSettings">
                <a-icon type="setting" />
                <span>&nbsp;{{ $t("Settings") }}</span>
              </div>
            </div>
          </div>
          <a-config-provider :locale="locale">
            <a-spin
              :spinning="spinning"
              size="large"
              style="background-color: white"
            >
              <div id="blockApp" class="mainpage">
                <firstTable
                  v-if="currentTab == 8"
                  :InitInfo="info"
                  :fileList="files || []"
                  :key_words="user_setup.words || []"
                  :responsible="user_setup.responsible || ''"
                  :specialization="user_setup.SPECJALIZACJA || []"
                  :user_setup="user_setup"
                  :USER_LIST="USER_LIST"
                  ref="firstTable"
                  :COMPANY_LIST="COMPANY_LIST"
                  :MY_COMPANY_LIST="MY_COMPANY_LIST"
                  @updateFiles="updateFiles"
                  @changeSpinning="changeSpinning"
                  @goToInvoice="goToInvoice"
                />
                <docTable
                  v-if="currentTab == 1"
                  :InitInfo="info"
                  :key_words="user_setup.words || []"
                  :responsible="user_setup.responsible || ''"
                  :specialization="user_setup.SPECJALIZACJA || []"
                  :user_setup="user_setup"
                  :USER_LIST="USER_LIST"
                  ref="docTable"
                  :COMPANY_LIST="COMPANY_LIST"
                  :MY_COMPANY_LIST="MY_COMPANY_LIST"
                  @updateFiles="updateFiles"
                  @changeSpinning="changeSpinning"
                  @goToInvoice="goToInvoice"
                />
                <invoiceTable
                  v-else-if="currentTab == 2"
                  :InitInfo="info"
                  :key_words="user_setup.words || []"
                  :responsible="user_setup.responsible || ''"
                  :specialization="user_setup.SPECJALIZACJA || []"
                  :user_setup="user_setup"
                  :placementDealID="placementDealID"
                  :placementCompanyID="placementCompanyID"
                  :goToInvoiceData="goToInvoiceData"
                  :COMPANY_LIST="COMPANY_LIST"
                  :DEAL_LIST="DEAL_LIST"
                  :MY_COMPANY_LIST="MY_COMPANY_LIST"
                  :USER_LIST="USER_LIST"
                  ref="invoiceTableRef"
                  @updateCompanyList="updateCompanyList"
                  @changeSpinning="changeSpinning"
                  @goToInvoice="goToInvoice"
                />
                <salesTable
                  v-else-if="currentTab == 3"
                  :info="info"
                  :user_setup="user_setup"
                  :responsible="user_setup.responsible || ''"
                  :placementDealID="placementDealID"
                  :placementCompanyID="placementCompanyID"
                  :COMPANY_LIST="COMPANY_LIST"
                  :MY_COMPANY_LIST="MY_COMPANY_LIST"
                  :USER_LIST="USER_LIST"
                  :VAT_LIST="info.VAT"
                  :dataSales="dataSales"
                  :invoiceMedia="invoiceMedia"
                  :checkMedia="checkMedia"
                  :checkMediaInvoice="checkMediaInvoice"
                  @updateCompanyList="updateCompanyList"
                  @onBackMedia="onBackMedia"
                  @changeSpinning="changeSpinning"
                />
                <exportXML
                  v-else-if="currentTab == 4"
                  :COMPANY_LIST="COMPANY_LIST"
                  :MY_COMPANY_LIST="MY_COMPANY_LIST"
                  :USER_LIST="USER_LIST"
                  @changeSpinning="changeSpinning"
                  @resizeFrame="resize"
                />
                <incomeStatement
                  v-else-if="currentTab == 5"
                  :costTypes="user_setup.CostTypes"
                  :COMPANY_LIST="COMPANY_LIST"
                  :MY_COMPANY_LIST="MY_COMPANY_LIST"
                  :DEAL_LIST="DEAL_LIST"
                  @changeSpinning="changeSpinning"
                  @resizeFrame="resize"
                  @goToBudget="goToBudget"
                />
                <mediaTab
                  v-else-if="currentTab == 106"
                  :settings="info"
                  :user_setup="user_setup"
                  :mediaForecasts="mediaForecasts"
                  :USER_ACTIVE="USER_ACTIVE"
                  :checkFacture="checkFacture"
                  :dataFacture="dataSales"
                  @openSalesTable="openSalesTable"
                  @openInvoice="openInvoice"
                />
                <budgetTab
                  v-else-if="currentTab == 6"
                  :settings="info"
                  :user_setup="user_setup"
                  :USER_ACTIVE="USER_ACTIVE"
                  :DEAL_LIST="DEAL_LIST"
                  @openSalesTable="openSalesTable"
                  @openInvoice="openInvoice"
                />
                <settingsApp
                  v-else-if="currentTab == 7 && info != null"
                  :settings="info"
                  :user_val="user_setup"
                  :COMPANY_LIST="MY_COMPANY_LIST"
                  @updateFiles="updateFiles"
                  @changeSpinning="changeSpinning"
                />
              </div>
            </a-spin>
          </a-config-provider>

          <!-- <div id="footer"></div> -->
          <a-divider />
          <div :style="{ width: '100%', 'background-color': iframeBackground }">
            <FooterApp :iframeColor="iframeColor" :iframeBackground="iframeBackground" />
          </div>



          <div v-if="license.trial">
            <DataUserCollectionForm />
          </div>

        </div>
      </a-spin>

    </div>



  </a-locale-provider>
</template>

<script>
import enUS from "ant-design-vue/es/locale/en_US";
import ruRU from "ant-design-vue/lib/locale-provider/ru_RU";
import plPL from "ant-design-vue/es/locale/pl_PL";
import invoiceTable from "./components/invoiceTable.vue";
import docTable from "./components/docTable.vue";
import firstTable from "./components/firstTable.vue";
import salesTable from "./components/sales_table.vue";
import exportXML from "./components/exportXML";
import incomeStatement from "./components/incomeStatement.vue";
import settingsApp from "./components/settingsApp.vue";
import mediaTab from "./components/mediaTab.vue";
import FooterApp from "./components/FooterApp.vue";
import DataUserCollectionForm from "./components/DataUserCollectionForm.vue";

import budgetTab from "./components/budgetTab";
import { getSettings } from "./requestFunc";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    docTable,
    firstTable,
    settingsApp,
    invoiceTable,
    incomeStatement,
    salesTable,
    mediaTab,
    budgetTab,
    exportXML,
    FooterApp,
    DataUserCollectionForm
  },
  computed: { ...mapGetters(["companyFieldForNIP"]) },
  data: function () {
    return {
      iframeColor: "#fff",
      iframeBackground: "#0083dc",

      moment,
      enUS,
      plPL,
      ruRU,
      locale: enUS,
      spinning: false,
      isAdmin: false,
      checkMedia: false,
      checkbudget: false,
      checkMediaInvoice: false,
      spinningMain: true,
      license: {
        status: false,
        trial: false,
      },
      info: {},
      dataSales: [],
      invoiceMedia: [],
      placementDealID: false,
      placementCompanyID: false,
      placementScope: false,
      user_setup: {},
      mediaForecasts: false,
      isResponsibleExport: false,
      media_setup: {},
      goToInvoiceData: undefined,
      files: [],
      currentTab: 0,
      COMPANY_LIST: {},
      MY_COMPANY_LIST: {},
      DEAL_LIST: {},
      USER_LIST: {},
      USER_ACTIVE: {},
      checkFacture: false,
    };
  },
  methods: {
    ...mapActions(["fetchCheckLicenseNip", "getAuth"]),
    updateFiles(data) {
      if (Array.isArray(data.files)) this.files = data.files;
      if (data.settings) {
        this.user_setup = Object.assign(this.user_setup, data.settings);
      }
    },
    goToInvoice(data) {
      if (data) this.currentTab = 2;
      this.goToInvoiceData = data;
    },
    changeSpinning(val) {
      if (val == undefined) {
        this.spinning = !this.spinning;
      } else {
        this.spinning = val;
      }
    },
    openSalesTable(data) {
      this.dataSales = data;
      this.currentTab = 3;
      this.checkMedia = true;
    },
    openInvoice(data) {
      let invoice = data.invoice;
      this.dataSales.filter = data.sort;
      this.currentTab = 3;
      this.checkMediaInvoice = true;
      this.invoiceMedia = invoice;
      // --- OPEN INVOICE
    },
    onBackMedia() {
      this.resize();
      this.checkFacture = true;
      this.checkMedia = false;
      this.checkMediaInvoice = false;
      this.currentTab = 6;
    },
    checkPlacementID() {
      let { placement, options } = BX24.placement.info();
      this.placementScope = placement;
      if (placement != "DEFAULT") {
        if (placement == "CRM_DEAL_DETAIL_TAB") {
          this.placementDealID = options.ID;
        } else if (placement == "CRM_COMPANY_DETAIL_TAB") {
          this.placementCompanyID = options.ID;
        }
        this.currentTab = 2;
      }
    },
    checkUrlInvoiceID() {
      let ID = this.getUrlParams("invoice");
      if (ID) {
        this.goToInvoice({ ID });
      }
    },
    resize() {
      setTimeout(
        () =>
          BX24.resizeWindow(
            parseInt($("body #root_block").css("width")),
            parseInt($("body #root_block").css("height"))
          ),
        100
      );
    },
    goToBudget() {
      this.currentTab = 6;
    },
    openFacture() {
      this.checkFacture = true;
      this.currentTab = 5;
    },
    updateCompanyList() {
      /*BX24.callMethod(
        "crm.company.list",
        {
          filter: {
            ">ID": this.info.company[this.info.company.length - 1].ID,
          },
          select: ["*", this.companyFieldForNIP],
        },
        (result) => {
          if (result.error()) console.error(result.error());
          else {
            let res = result.data();
            this.info.company.push(...res);
            for (let i of res) {
              this.COMPANY_LIST[i.ID] = i;
            }
            if (result.more()) result.next();
          }
        }
      );*/
    },
    getUrlParams(key) {
      let url_str = document.referrer;
      let url = new URL(url_str);
      let search_params = url.searchParams;
      return search_params.get(key);
    },
  },
  async mounted() {
    BX24.init(async () => {
      this.getAuth();

      let langNotHave = [
        "br",
        "tr",
        "ja",
        "ms",
        "fr",
        "sc",
        "vn",
        "th",
        "la",
        "it",
        "ua",
        "tc",
        "id",
        "hi",
      ];

      if (langNotHave.includes(BX24.getLang())) {
        this.$i18n.locale = "en";
      } else {
        this.$i18n.locale = BX24.getLang();
      }

      if (this.$i18n.locale == "pl") {
        this.locale = plPL;
      } else if (this.$i18n.locale == "ru") {
        this.locale = ruRU;
      }
      // console.log(BX24.getLang(), "lang");
      //let resp = await checkLicense();
      /* console.log(resp, 'resp');
      if (resp.ok) {
        try {
          this.license.status = true;
        } catch (error) {
          console.error("checkLicense", error);
        }
      }*/
      // this.license.status = true;
      await this.fetchCheckLicenseNip();

      let resp_getSettings = await getSettings();

      if (resp_getSettings.ok) {
        let vals = await resp_getSettings.json();

        // console.log({
        //   isBefore:moment().isBefore(vals.license.trial_end_date),
        //   license:vals.license,
        //   trial_end_date:vals.license.trial_end_date,
        // });

        if (!vals.license.lic_key) {
          if (moment().isBefore(vals.license.trial_end_date)) {
            this.license.status = true;
          }
          this.license.trial = true;

        } else {
          if (moment().isBefore(vals.license.lic_end_date)) {
            this.license.status = true;
          }
        }

        // this.license.status = true;

        vals.option_get.responsible = vals.option_get.responsible
          ? JSON.parse(vals.option_get.responsible)
          : "";
        vals.option_get.responsibleSpredz = vals.option_get.responsibleSpredz
          ? JSON.parse(vals.option_get.responsibleSpredz)
          : [];
        vals.option_get.responsibleExport = vals.option_get.responsibleExport
          ? JSON.parse(vals.option_get.responsibleExport)
          : [];
        vals.option_get.responsibleAll = vals.option_get.responsibleAll
          ? JSON.parse(vals.option_get.responsibleAll)
          : [];
        vals.option_get.responsibleOffice = vals.option_get.responsibleOffice
          ? JSON.parse(vals.option_get.responsibleOffice)
          : [];
        vals.option_get.responsibleRead = vals.option_get.responsibleRead
          ? JSON.parse(vals.option_get.responsibleRead)
          : [];
        vals.option_get.mediaAssigned = vals.option_get.mediaAssigned
          ? JSON.parse(vals.option_get.mediaAssigned)
          : [];
        vals.option_get.templateSettings =
          vals.option_get.templateSettings || [];
        vals.option_get.words = vals.option_get.words || [];
        vals.option_get.numberInvoice = vals.option_get.numberInvoice || [];
        // vals.option_get.my_company = vals.option_get.my_company || [];
        if (vals.option_get.my_company == null) vals.option_get.my_company = [];
        if (vals.my_company == null) vals.my_company = [];
        vals.option_get.typeInvoice = vals.option_get.typeInvoice || {};
        vals.option_get.mediaResponsible =
          vals.option_get.mediaResponsible &&
          vals.option_get.mediaResponsible != "null"
            ? JSON.parse(vals.option_get.mediaResponsible)
            : [];
        /*var fields = [];
        for (let i in vals.userfields) {
          if (vals.userfields[i]["listLabel"] != undefined) {
            fields.push(vals.userfields[i]);
          }
        }*/

        var reportInv = [];
        var reportSales = [];

        if ("reportInvoices" in vals.option_get) {
          reportInv =
            vals.option_get.reportInvoices == ""
              ? []
              : JSON.parse(vals.option_get.reportInvoices);
        }

        if ("reportSales" in vals.option_get) {
          reportSales =
            vals.option_get.reportSales == ""
              ? []
              : JSON.parse(vals.option_get.reportSales);
        }

        this.info = {
          numeratorField: vals.option_get.numeratorField,
          license: vals.license,
          api_ocr_token: vals.api_ocr_token,
          crm_status_list: vals.crm_status_list,
          // data_getchildren: vals.data_getchildren,
          data_user: vals.data_user,
          //  company: vals.company,
          totalForMail: vals.totalForMail,
          //userfields: fields,
          rightsToInvoiceFunnel: vals.option_get.rightsToInvoiceFunnel || [],
          my_company: vals.my_company,
          // deal: vals.deal,
          //  user_folder: vals.option_get.folder,
          nip: vals.option_get.nip,
          teczkalist: vals.option_get.teczkalist,
          matrix: vals.right,
          VAT: vals.VAT,
          reports: {
            invoices: reportInv,
          },
          reportSales: {
            sales: reportSales,
          },
          currency: vals.currency,
          costCenter: vals.costCenter,
          defaultResponsible: {
            verification: vals.option_get.verification,
            processing: vals.option_get.processing,
          },
          media: {
            assigned: vals.option_get.mediaAssigned,
            responsible: vals.option_get.mediaResponsible,
          },
          option_get: vals.option_get,
        };
        /*for (let i of this.info.company) {
          this.COMPANY_LIST[i["ID"]] = i;
        }
        for (let i of this.info.data_user) {
          this.USER_LIST[i["ID"]] = i;
        }
        for (let i of this.info.deal) {
          this.DEAL_LIST[i["ID"]] = i;
        }*/
        for (let i of this.info.data_user) {
          this.USER_LIST[i["ID"]] = i;
        }

        // console.log(this.info, "info");

        for (let i of this.info.my_company) {
          this.MY_COMPANY_LIST[i["ID"]] = i;
          let user =
            this.USER_LIST[this.MY_COMPANY_LIST[i["ID"]]["ASSIGNED_BY_ID"]];
          this.MY_COMPANY_LIST[i["ID"]]["ASSIGNED_BY_NAME"] = user
            ? `${user.NAME} ${user.LAST_NAME}`
            : "";
        }
        // if (Array.isArray(vals.data_file)) this.files = vals.data_file;
        //for (let i in this.files) this.files[i]["key"] = i;
        this.user_setup = vals.option_get;
        this.$notification.info({
          message: this.$t("Download complete!"),
        });
      } else {
        this.$notification.error({
          message: this.$t("Error loading files"),
          description: "Ошибка HTTP: " + resp_getSettings.status,
        });
      }
      if (this.license.status) {
        this.currentTab = 8;
      } else {
        this.currentTab = 7;
      }
      BX24.callMethod("profile", {}, (res) => {
        this.USER_ACTIVE = res.data();
        this.isAdmin = this.USER_ACTIVE.ADMIN;
        this.checkbudget =
          this.user_setup.mediaResponsible.includes(this.USER_ACTIVE.ID) ||
          this.isAdmin
            ? true
            : false;
        this.isResponsibleExport =
          this.isAdmin ||
          (this.user_setup.responsibleExport &&
            this.user_setup.responsibleExport.includes(this.USER_ACTIVE.ID));
        this.spinningMain = false;
        if (this.license.status) {
          //  this.$refs.docTable.lastKeyFiles = this.files?.length;
          this.checkPlacementID();
          this.checkUrlInvoiceID();
        }
        BX24.fitWindow();
      });
    });
  },
};
</script>
<style>
#app {
  width: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#app .ant-form-item-label {
  display: flex;
  align-items: center;
}

#app #settings_main_form .ant-form-item-label {
  justify-content: flex-end;
  padding-top: 18px;
}

#app #createStep .ant-form-item-label {
  justify-content: flex-end;
}

#app .ant-form-item-control,
#app .ant-form-item-label,
#app .ant-form-item-control-wrapper {
  line-height: 0.8;
  padding: 5px;
}

#app
  .ant-table-middle
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-tbody
  > tr
  > td,
#app
  .ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-tbody
  > tr
  > td,
#app
  .ant-table-middle
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th,
#app
  .ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-thead
  > tr
  > th,
#app
  .ant-table-middle
  > .ant-table-content
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th,
#app .ant-table-thead > tr > th {
  padding: 0px 8px !important;
}
#root_block,
#root_block > .ant-spin-container {
  width: 100%;
}

/* #app .ant-table-tbody > tr > td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
</style>
